import { render, staticRenderFns } from "./AppUserFields.vue?vue&type=template&id=63876154&lang=pug&"
import script from "./AppUserFields.vue?vue&type=script&lang=ts&"
export * from "./AppUserFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports